import cx from 'classnames';
import * as React from 'react';
import Text from 'components/Text';
import Glyph from 'components/Glyph';
import ReactionPickerTrigger from 'chat/components/ReactionPickerTrigger';
import { getUniqueUsers } from 'chat/lib/reactionsCopyHelper';
import type { ReactionSummaryFragment } from './Reaction/__generated__/ReactionSummaryFragment';

import './styles/ReactionStatus.scss';

type Props = {
  sentBySelf?: boolean;
  addReactionToSummary: (name: string) => void;
  removeReactionFromSummary: (name: string) => void;
  reactionSummary: ReactionSummaryFragment | undefined | null;
};

function hasNoReactions(reactionSummary?: ReactionSummaryFragment | null) {
  return !reactionSummary || reactionSummary.reactions.length <= 0;
}

export default function ReactionStatus(props: Props) {
  const { reactionSummary, sentBySelf } = props;
  const noReactions = hasNoReactions(reactionSummary);

  if (sentBySelf && noReactions) {
    return null;
  }

  // This can be caused by hermes timeouts. Since we have no useful information to show, just abort
  // https://app.asana.com/0/32507888495125/395443531020487
  if (!noReactions && reactionSummary && getUniqueUsers(reactionSummary).length === 0) {
    return null;
  }

  if (noReactions) {
    return (
      <div className={cx('ReactionStatus', { 'ReactionStatus-nullState': noReactions })}>
        <ReactionPickerTrigger
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: Element[]; alignment: string; cl... Remove this comment to see the full error message
          alignment="left"
          className="ReactionStatus-info"
          addReactionToSummary={props.addReactionToSummary}
          removeReactionFromSummary={props.removeReactionFromSummary}
        >
          <Glyph className="ReactionStatus-info-glyph" name="reaction-smiley" size="large" />
          <Text className="ReactionStatus-info-text" size="xxxsmall">
            Be the first to leave a reaction
          </Text>
          <div className="ReactionStatus-info-spacer" />
        </ReactionPickerTrigger>
      </div>
    );
  }

  return null;
}
